import { action } from 'typesafe-actions';

import { VehicleDetailResponse } from 'models/auto/vehicleDetail';
import { VehicleFilter } from 'models/auto/vehicleFilter';
import { VehicleResultsResponse } from 'models/auto/vehicleResults';
import { VehicleResultsFilters } from 'models/auto/vehicleResults';
import { VehicleSearchResponse } from 'models/auto/vehicleSearch';
import { VehiclePlace } from 'models/auto/vehicleSearch';
import { VehicleValidateResponse } from 'models/auto/vehicleValidate';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { TravelArrangerUsersAllowed } from 'services/userService';

export const AUTOS_SEARCH_PARAMETERS = 'AUTOS_SEARCH_PARAMETERS';
export const AUTOS_SEARCH_REQUEST = 'AUTOS_SEARCH_REQUEST';
export const AUTOS_SEARCH_SUCCESSFUL = 'AUTOS_SEARCH_SUCCESSFUL';
export const AUTOS_SEARCH_FAILURE = 'AUTOS_SEARCH_FAILURE';
export const AUTOS_RESULT_REQUEST = 'AUTOS_RESULT_REQUEST';
export const AUTOS_RESULT_SUCCESSFUL = 'AUTOS_RESULT_SUCCESSFUL';
export const AUTOS_RESULT_FAILURE = 'AUTOS_RESULT_FAILURE';
export const AUTOS_RESULT_CLEAR = 'AUTOS_RESULT_CLEAR';
export const AUTOS_AGENCIES_REQUEST = 'AUTOS_AGENCIES_REQUEST';
export const AUTOS_AGENCIES_SUCCESSFUL = 'AUTOS_AGENCIES_SUCCESSFUL';
export const AUTOS_AGENCIES_FAILURE = 'AUTOS_AGENCIES_FAILURE';
export const AUTOS_AGENCIES_CLEAR = 'AUTOS_AGENCIES_CLEAR';
export const AUTOS_FILTER_CLEAR = 'AUTOS_FILTER_CLEAR';
export const AUTOS_TAB_FILTER = 'AUTOS_TAB_FILTER';
export const AUTOS_CLEAR = 'AUTOS_CLEAR';
export const AUTOS_SET_TRAVELER = 'AUTOS_SET_TRAVELER';
export const AUTOS_DETAILS_REQUEST = 'AUTOS_DETAILS_REQUEST';
export const AUTOS_DETAILS_SUCCESSFUL = 'AUTOS_DETAILS_SUCCESSFUL';
export const AUTOS_VALIDATE_REQUEST = 'AUTOS_VALIDATE_REQUEST';
export const AUTOS_VALIDATE_SUCCESSFUL = 'AUTOS_VALIDATE_SUCCESSFUL';
export const AUTOS_CHANGE_RESULT_PAGINATION = 'AUTOS_CHANGE_RESULT_PAGINATION';

interface AutosSearchRequestArguments {
  pickUpPoint?: VehiclePlace;
  dropOffPoint?: VehiclePlace;
  pickUpDate?: string;
  pickUpTime?: string;
  dropOffDate?: string;
  dropOffTime?: string;
  traveler?: TravelArrangerUsersAllowed;
  diffDropOff: boolean;
  branchCompany?: GetAllBillingCompanyResponse;
}

export const autosSearchRequest = ({
  pickUpPoint,
  dropOffPoint,
  pickUpDate,
  pickUpTime,
  dropOffDate,
  dropOffTime,
  traveler,
  diffDropOff,
  branchCompany,
}: AutosSearchRequestArguments) =>
  action(AUTOS_SEARCH_REQUEST, {
    pickUpPoint,
    dropOffPoint,
    pickUpDate,
    pickUpTime,
    dropOffDate,
    dropOffTime,
    traveler,
    diffDropOff,
    branchCompany,
  });

export const autosSearchParameters = ({
  pickUpPoint,
  dropOffPoint,
  pickUpDate,
  pickUpTime,
  dropOffDate,
  dropOffTime,
  traveler,
  diffDropOff,
  branchCompany,
}: AutosSearchRequestArguments) =>
  action(AUTOS_SEARCH_PARAMETERS, {
    pickUpPoint,
    dropOffPoint,
    pickUpDate,
    pickUpTime,
    dropOffDate,
    dropOffTime,
    traveler,
    diffDropOff,
    branchCompany,
  });

export const autosTabFilterSuccessful = (filter: VehicleFilter) => action(AUTOS_TAB_FILTER, filter);

export const autosSearchSuccessful = (search: VehicleSearchResponse) => action(AUTOS_SEARCH_SUCCESSFUL, search);

export const autosSearchError = (error: string) => action(AUTOS_SEARCH_FAILURE, error);

export const autoResultsRequest = (filters?: VehicleResultsFilters) => action(AUTOS_RESULT_REQUEST, { filters });

export const autoResultsSuccessful = (result: VehicleResultsResponse) => action(AUTOS_RESULT_SUCCESSFUL, result);

export const changeResultPagination= (countLowerBound, countUpperBound) => action(AUTOS_CHANGE_RESULT_PAGINATION, {countLowerBound, countUpperBound});

export const autoResultsError = (error: string) => action(AUTOS_RESULT_FAILURE, error);

export const autoResultsClear = () => action(AUTOS_RESULT_CLEAR);

export const autoAgenciesRequest = (model: string, company: string) =>
  action(AUTOS_AGENCIES_REQUEST, { model, company });

export const autoAgenciesSuccessful = (result: VehicleResultsResponse) => action(AUTOS_AGENCIES_SUCCESSFUL, result);

export const autoAgenciesError = (error: string) => action(AUTOS_AGENCIES_FAILURE, error);

export const autoAgenciesClear = () => action(AUTOS_AGENCIES_CLEAR);

export const autosFilterClear = () => action(AUTOS_FILTER_CLEAR);

export const autosClear = () => action(AUTOS_CLEAR);

export const autosSetTraveler = (traveler?: TravelArrangerUsersAllowed) => action(AUTOS_SET_TRAVELER, traveler);

export const autoDetailsRequest = (searchId: string, optionId: number) =>
  action(AUTOS_DETAILS_REQUEST, { searchId, optionId });

export const autoDetailsSuccess = (result: VehicleDetailResponse) => action(AUTOS_DETAILS_SUCCESSFUL, result);

export const autoValidateRequest = (detailId: string) => action(AUTOS_VALIDATE_REQUEST, detailId);

export const autoValidateSuccess = (result: VehicleValidateResponse) => action(AUTOS_VALIDATE_SUCCESSFUL, result);
